import { Typography , Grid } from "@mui/material";

const EditableInput = ({ value, onChange, readOnly, error, placeholder, fontSize = '14px' }) => {
  return (
    <Grid display='flex' flexDirection='column' width='100%'>
      <input
        style={{
          border: error ? '1px solid red' : '1px solid #b8bdc9',
          borderRadius: '3px',
          padding: '10px',
          width: '100%',
          fontSize,
          fontWeight: 700,
          lineHeight: 1.45,
          color: '#222',
          display:'block'
        }}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
      />
      {error && value && (
        <Typography variant="subtitle2" color="#FF0000" fontWeight={700}>{error}</Typography>
      )}
    </Grid>
  );
};

export default EditableInput;
